import React, { useState } from "react";
import hamburger_icon from "../../assets/icons/hamburger_icon.png";
import SearchBar from "../../components/SearchBar";
import Navbar from "../../components/Navbar";
import FontSizeChanged from "../../components/modals/FontSizeChanged";

const Fonts = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);
  const [font, setFont] = useState("Poppins");
  const [fontSize, setFontSize] = useState(22);
  const [fontChange, setFontChange] = useState(false);

  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };

  const handleFontSizeChange = (event) => {
    setFontSize(parseInt(event.target.value));
  };

  const closeModal = () => {
    setFontChange(false);
  };

  return (
    <div>
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img
            src={hamburger_icon}
            alt="hamburger"
            className="object-contain"
          />
        </div>
        <div className="flex items-center justify-center w-full">
          <SearchBar categoryName="Profile" />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <Navbar />}
        </div>
      </div>

      <div className="ml-4 mt-10">
        <p className="text-[18px] font-bold">Fonts</p>
      </div>

      <div className="ml-4 mt-8 flex justify-between w-[90%] flex--cards">
        <div
          style={{ fontSize: `${fontSize}px` }}
          className={`font-${font} border-2 px-6 py-2 w-[60%] rounded-lg text-[#606060] profile-section-width `}
        >
          <p className="">Heading text</p>
          <p className=" mt-4">
            Normal text: This is how a normal text will look.
          </p>
          <p className="mt-4">
            Smaller text: This is how a smaller text will look like in your
            application. This text will go in paragraphs.
          </p>
          <p className="mt-4">Number text: 0123456789</p>
        </div>

        <div className=" w-[30%] mt-4 profile-section-width">
          <div className="flex justify-around ">
            <div className="flex flex-col items-center">
              <div
                className={`${
                  font === "Poppins" ? "border-2" : ""
                } border-[#F6B801] rounded-lg`}
                onClick={() => setFont("Poppins")}
              >
                <div className="border-4 px-6 py-1 font-bold text-center rounded-lg text-[36px] cursor-pointer">
                  Aa
                </div>
              </div>
              <p className="text-[text-[#606060]] text-[14px] italic mt-2">
                Poppins
              </p>
            </div>
            <div className="flex flex-col items-center">
              <div
                className={`${
                  font === "Roboto" ? "border-2" : ""
                } border-[#F6B801] rounded-lg`}
                onClick={() => setFont("Roboto")}
              >
                <div className="border-4 px-6 py-1 font-bold text-center rounded-lg text-[36px] cursor-pointer font-roboto">
                  Aa
                </div>
              </div>
              <p className="text-[text-[#606060]] text-[14px] italic mt-2">
                Roboto
              </p>
            </div>
            <div className="flex flex-col items-center">
              <div
                className={`${
                  font === "Montserrat" ? "border-2" : ""
                } border-[#F6B801] rounded-lg`}
                onClick={() => setFont("Montserrat")}
              >
                <div className="border-4 px-6 py-1 font-bold text-center rounded-lg text-[36px] cursor-pointer font-Montserrat">
                  Aa
                </div>
              </div>
              <p className="text-[text-[#606060]] text-[14px] italic mt-2">
                Montserrat
              </p>
            </div>
          </div>

          <div className="mt-8 ml-4 w-full">
            <p className="font-bold text-[18px]">Font Size</p>
            <div className="w-full">
              <input
                type="range"
                className="w-full"
                min="8"
                max="100"
                value={fontSize}
                onChange={handleFontSizeChange}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-28 flex justify-center w-[90%]">
        <div
          className="text-[#2F80ED] border text-center border-[#2F80ED] rounded-lg w-[15rem] p-1 cursor-pointer mb-10"
          to="/profile"
          onClick={() => setFontChange(true)}
        >
          Apply
        </div>
      </div>

      {fontChange ? <FontSizeChanged closeModal={closeModal} /> : ""}
    </div>
  );
};

export default Fonts;
